import { combineReducers } from 'redux-immutable'

import data from './data'
import ui from './ui'
import edit from './edit'

export default combineReducers({
  data,
  ui,
  edit
})
